import React from 'react';

export default ({ record, label }: { record?: any; label?: string }) => {
    const invoiceNo = `${record.type === 'creditNote' ? 'CN' : 'IN'}${
        record.countryId === 1 ? 'AE' : record.countryId === 2 ? 'KW' : 'SA'
    }${record.id}`;
    return <span>{invoiceNo}</span>;
};
